//Script added by Jake DeWitt to preload the product images to avoid flicker/delay in loading the next image
document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on a product page
  if (!document.querySelector('.product__media-container')) return;
  
  // Create a hidden container for preloaded images
  const preloadContainer = document.createElement('div');
  preloadContainer.style.cssText = 'position: absolute; width: 1px; height: 1px; overflow: hidden; opacity: 0; pointer-events: none;';
  preloadContainer.setAttribute('aria-hidden', 'true');
  document.body.appendChild(preloadContainer);
  
  // Get all variant image URLs from the page
  const preloadedImages = new Set();
  const variantImageUrls = [];
  
  // Find all image URLs in thumbnails
  document.querySelectorAll('.product-thumbnails__item-image img').forEach(img => {
    const srcset = img.getAttribute('srcset');
    if (srcset) {
      // Extract the highest resolution image URL
      const srcsetParts = srcset.split(',');
      if (srcsetParts.length > 0) {
        const lastPart = srcsetParts[srcsetParts.length - 1].trim();
        const urlMatch = lastPart.match(/(.+)\s+\d+w/);
        if (urlMatch && urlMatch[1]) {
          variantImageUrls.push(urlMatch[1]);
        }
      }
    }
  });
  
  // Function to preload an image
  function preloadImage(url) {
    if (!url || preloadedImages.has(url)) return;
    
    const img = new Image();
    img.onload = () => preloadedImages.add(url);
    img.src = url;
    preloadContainer.appendChild(img);
  }
  
  // Preload all variant images with a slight delay to not block initial page load
  setTimeout(() => {
    variantImageUrls.forEach((url, index) => {
      setTimeout(() => {
        preloadImage(url);
      }, index * 100); // Stagger the loading to avoid overwhelming the browser
    });
  }, 500);
  
  // Simple style to ensure hidden items are not displayed
  const styleElement = document.createElement('style');
  styleElement.textContent = `
    .product__media-item.hidden {
      display: none !important;
    }
  `;
  document.head.appendChild(styleElement);
});


// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
// document.addEventListener("cart:item-added", function (evt) {
//   console.log("Item added to the cart");
//   console.log(evt.detail.product);
// });

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
// document.addEventListener("cart:updated", function (evt) {
//   console.log("Cart updated");
//   console.log(evt.detail.cart);
// });

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
// document.addEventListener("cart:error", function (evt) {
//   console.log("Cart error");
//   console.log(evt.detail.errorMessage);
// });

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
// document.addEventListener("quick-cart:open", function (evt) {
//   console.log("Quick cart opened");
//   console.log(evt.detail.cart);
// });

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// document.addEventListener("quick-cart:close", function () {
//   console.log("Quick cart closed");
// });

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
// document.addEventListener("product:variant-change", function (evt) {
//   console.log("Product variant changed");
//   console.log(evt.detail.variant);
// });

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
// document.addEventListener("product:quantity-update", function (evt) {
//   console.log("Product quantity updated");
//   console.log(evt.detail.quantity, evt.detail.variant);
// });

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
// document.addEventListener("quickview:loaded", function () {
//   console.log("Quickview loaded");
// });



